//时间戳转时间
const timestampToTime = (timestamp) => {
	if (!timestamp) return ""
	var date = new Date(timestamp + 8 * 3600 * 1000); // 增加8小时
	return date.toJSON().substr(0, 19).replace('T', ' ');
}

// 判断前后是否含有""
const isQuoted = (str) => {
	return str.startsWith('"') && str.endsWith('"');
}

// 判断设备是否为移动端
const isMobile = () => {
  return /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i.test(
    navigator.userAgent
  );
};

// 修改md文件里的图片链接
const updatedMarkdownText = (markdownText, url) => {
	var mdUrl = process.env.VUE_APP_FILE_URL + url
	var imgBaseUrl = mdUrl.substring(0, mdUrl.lastIndexOf("\/") + 1)
	const regex = /!\[.*?\]\((images\/[^)]+)\)/g;
	return markdownText.replace(regex, `![](${imgBaseUrl}$1)`);
}



export default {
	timestampToTime,
	isQuoted,
	isMobile,
	updatedMarkdownText
}